import { Observable } from 'rxjs';
import { CompanyOption } from '../../../models/company-option.model';
import { InjectionToken } from '@angular/core';
import { LoaderService } from '../../loader.service';

export const DI_COMPANY_OPTIONS_PROVIDER = new InjectionToken<ICompanyOptionsProvider>(
  'Provider which implementing ICompanyOptionsProvider interface'
);

export interface ICompanyOptionsProvider {
  loaderService: LoaderService;

  getCompanyOptions(companyId: number): Observable<CompanyOption[]>;

  createCompanyOption(companyId: number, data: Partial<CompanyOption>): Observable<CompanyOption>;

  getCompanyOption(companyId: number, companyOptionId: number): Observable<CompanyOption>;

  toggleCompanyOptionActivation(companyId: number, companyOptionId: number): Observable<any>;

  updateCompanyOption(
    companyId: number,
    companyOptionId: number,
    data: Partial<CompanyOption>
  ): Observable<CompanyOption>;

  deleteCompanyOption(companyId: number, companyOptionId: number): Observable<any>;
}
